import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n/i18n';
import GlobalStyles from './styles/GlobalStyles';
import Layout from './components/layout/Layout';
import SplashScreen from './pages/SplashScreen';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import GalleryPage from './pages/GalleryPage';
import CVPage from './pages/CVPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const { i18n } = useTranslation();
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Set document title based on language
    document.title = i18n.language === 'pl' 
      ? 'Bartłomiej Zawadzki - Portfolio' 
      : 'Bartłomiej Zawadzki - Portfolio';
      
    // Set html lang attribute
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  
  if (showSplash) {
    return <SplashScreen onCompleted={() => setShowSplash(false)} />;
  }

  return (
    <Router>
      <GlobalStyles />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/cv" element={<CVPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
